/**
 * Asset selector - search module
 *
 * This module makes ajax calls to search for assets
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.dam.assetselector.search');

goog.require('yext');
goog.require('yext.dam.routes');
goog.require('yext.ui.SearchableList');

// This flag is true when a search is in progress (waiting for response)
yext.dam.assetselector.search.searching = false;

// This flag is true when a search is no longer returning results
yext.dam.assetselector.search.searchComplete = false;

// Height before the bottom of scroll that more assets will be loaded
yext.dam.assetselector.search.scrollToLoadHeight = 100;

/**
 * Default search parameters
 */
var defaultSearchParams = {
  // The number of search results returned
  limit: 16,

  // Start is the equivalent of offset in a MySQL query
  start: 0,

  // Restrict search to assets with the given label id
  labelId: undefined,

  // Asset Usage type
  usageType: undefined,

  // Asset query string
  searchString: undefined,
};

/**
 * Initialize search module
 *
 * @param {!jQuery} $context Context for DOM
 * @param {function()} success Search success callback
 * @param {function()} error Search error callback
 */
yext.dam.assetselector.search.init = function($context, success, error, locationSearchParam) {
  yext.dam.assetselector.search.$assetList = $context.find('.js-asset-list');
  yext.dam.assetselector.search.$searchableListWrapper = $context.find('.js-selector-searchablelist-wrapper');
  yext.dam.assetselector.search.$searchableListBtn = $context.find('.js-label-picker-btn');
  yext.dam.assetselector.search.$inputBox = $context.find('.js-library-search-text');

  yext.dam.assetselector.search.success = success;
  yext.dam.assetselector.search.error = error;

  defaultSearchParams.locationSearchParam = locationSearchParam;
  yext.dam.assetselector.search.params = $.extend({}, defaultSearchParams);

  yext.dam.assetselector.search.bindScroll();
  yext.dam.assetselector.search.bindLabelSearchDropdown();
  yext.dam.assetselector.search.bindSearchInputBox();
};

/**
 * Bind scroll on asset list to load more assets
 */
yext.dam.assetselector.search.bindScroll = function() {
  yext.dam.assetselector.search.$assetList.scroll(function() {
    yext.dam.assetselector.search.$searchableListWrapper.hide();
    if (!yext.dam.assetselector.search.searching && !yext.dam.assetselector.search.searchComplete) {
      var scrollTop = yext.dam.assetselector.search.$assetList.scrollTop();
      var height = yext.dam.assetselector.search.$assetList.outerHeight();
      var scrollHeight = yext.dam.assetselector.search.$assetList.prop('scrollHeight');

      if (scrollTop + height >= scrollHeight - yext.dam.assetselector.search.scrollToLoadHeight) {
        yext.dam.assetselector.search.make(true);
      }
    }
  });
};

/** Hide the label search dropdown button */
yext.dam.assetselector.search.hideLabelSelector = function() {
  yext.dam.assetselector.search.$searchableListBtn.hide();
};

/**
 * Bind label search dropdown button
 */
yext.dam.assetselector.search.bindLabelSearchDropdown = function() {
  yext.dam.assetselector.search.$searchableListBtn.on('click', function() {
    yext.dam.assetselector.search.$searchableListWrapper.toggle();
  });
};

/**
 * Bind searchable list module in the dialog box
 * NOTE: Need to call this binding AFTER creating the searchable list
 */
yext.dam.assetselector.search.searchableList = function() {
  yext.dam.assetselector.search.$searchableListWrapper.empty();
  var searchableList = new yext.ui.SearchableList({
    target: '.js-selector-searchablelist-wrapper',
    findAnItemText: yext.msgc('dam', 'Find a label'),
    allItemsText: yext.msgc('dam', 'All Labels'),
    showAddLink: false,
    showDropdown: false,
    ajaxParams: $.extend({}, yext.dam.assetselector.search.params),
    url: goog.module.get('yext.dam.routes').default.getLabelsOnAssets(),
  }).init();

  var $labelList = searchableList.$list;
  $labelList.on('selected.searchableList', function(e, obj) {
    yext.dam.assetselector.search.$searchableListBtn
      .find('span')
      .last()
      .text(obj.name);

    yext.dam.assetselector.search.params.labelName = obj.id === 0 ? undefined : obj.name;
    yext.dam.assetselector.search.make();
    yext.dam.assetselector.search.$searchableListWrapper.hide();
  });
};

/**
 * Bind the search box to make an ajax call to get results on input change.
 * Ajax request is fired 0.5 second after last input change
 * @suppress {deprecated}
 */
yext.dam.assetselector.search.bindSearchInputBox = function() {
  var timeout;

  // on key press fire an ajax request 0.5s after the last input change
  // If the key pressed is enter fire the ajax request immediately
  // If the search string has not changed don't fire the ajax request
  yext.dam.assetselector.search.$inputBox.on('keyup', function(e) {
    var delay = e.keyCode === $.ui.keyCode.ENTER ? 0 : 500;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      if (yext.dam.assetselector.search.params.searchString !== yext.dam.assetselector.search.$inputBox.val()) {
        yext.dam.assetselector.search.$searchableListWrapper.hide();
        yext.dam.assetselector.search.params.searchString = yext.dam.assetselector.search.$inputBox.val();
        yext.dam.assetselector.search.make();
      }
    }, delay);
  });
};

/**
 * Reset to focus on the search box
 */
yext.dam.assetselector.search.focusOnInputBox = function() {
  yext.dam.assetselector.search.$inputBox.focus();
};

/**
 * Set the search parameters by extending the params object
 *
 * @param {!Object} params A search parameters object
 */
yext.dam.assetselector.search.setParams = function(params) {
  if (typeof params == 'object') {
    $.extend(true, yext.dam.assetselector.search.params, params);
  }
};

/**
 * Resets the state of the search object
 */
yext.dam.assetselector.search.reset = function() {
  yext.dam.assetselector.search.params = $.extend({}, defaultSearchParams);
  yext.dam.assetselector.search.$searchableListWrapper.hide();
  yext.dam.assetselector.search.$inputBox.val('');
  yext.dam.assetselector.search.$searchableListBtn
    .find('span')
    .text(yext.msg('Labels'));
};

/**
 * Make an asset search
 *
 * NOTE(mattjs) : params should not change the limit or some of the scroll
 * logic will be disrupted
 *
 * @param {boolean} append This flag indicates if the request is part of
 * continuing a paged search or if the search is new
 */
yext.dam.assetselector.search.make = function(append) {
  yext.dam.assetselector.search.searching = true;

  if (typeof append != 'boolean') {
    append = false;
  }

  // Reset the continuing search variables
  if (!append) {
    $(yext.dam.assetselector.search).trigger('newSearch.assetselector');
    yext.dam.assetselector.search.searchComplete = false;
    yext.dam.assetselector.search.params.start = 0;
  }

  $.ajax({
    url: goog.module.get('yext.dam.routes').default.search(),
    data: yext.dam.assetselector.search.params,
    success: function(response) {
      // Set search complete to true if the result set is smaller than limit
      if (response.assets.length < yext.dam.assetselector.search.params.limit) {
        yext.dam.assetselector.search.searchComplete = true;
      }

      yext.dam.assetselector.search.params.start += yext.dam.assetselector.search.params.limit;

      yext.dam.assetselector.search.success(response, append);
    },
    error: yext.dam.assetselector.search.error,
  }).always(function() {
    yext.dam.assetselector.search.searching = false;
  });
};
